import { IMAGE_MODE, PROJECT_MODE } from './constants';

/**
 * The project type (`PROJECT_MODE`) a project's backend `image_mode` maps to.
 * Both orthophoto variants are orthophoto; anything unknown defaults to it.
 *
 * Project.context keeps its own copy of this rule (`setProjectMode`); folding
 * it onto this helper is a follow-up outside the objects work.
 */
export const projectModeFromImageMode = imageMode => {
	switch (imageMode) {
		case IMAGE_MODE.SINGLE_IMAGE:
			return PROJECT_MODE.SINGLE_IMAGE;
		case IMAGE_MODE.GENERATE_ORTHOPHOTO:
		case IMAGE_MODE.UPLOAD_ORTHOPHOTO:
		default:
			return PROJECT_MODE.ORTHOPHOTO;
	}
};
